import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "label", "className", "type", "iconKey", "defaultValue", "trailingSlot"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { twMerge } from 'tailwind-merge';
import React, { forwardRef } from 'react';
import Icon from './Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Never destructure `value` here and write it back as `value={...}`. That makes
 * it an own property even when the caller passed none, which sends React down
 * the `props.hasOwnProperty('value')` branch of `updateWrapper` and restores the
 * mount-time value instead of an updated `defaultValue` — silently breaking
 * every uncontrolled caller whose value arrives after mount. Let it ride the
 * spread. Covered by 'adopts a defaultValue that arrives after mount'.
 */
var BaseInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    iconKey = _ref.iconKey,
    defaultValue = _ref.defaultValue,
    trailingSlot = _ref.trailingSlot,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex w-full flex-col gap-y-1.5",
    children: [label && /*#__PURE__*/_jsx("label", {
      htmlFor: id,
      className: "flex text-sm font-bold text-gray-800",
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative w-full rounded-sm",
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        id: id,
        ref: ref,
        type: type,
        defaultValue: defaultValue
        // Only when there is no visible label to point at:
        // otherwise the label above already names the field,
        // and a second name would override what is on screen.
        ,
        "aria-label": label ? undefined : props.placeholder,
        className: twMerge('form-input bg-gray-150 focus-ring block h-10 w-full rounded-sm border-0 p-3 text-sm/3 text-gray-800 placeholder:text-gray-500 read-only:bg-gray-100 focus:ring-0 disabled:text-gray-400 dark:bg-gray-100 dark:disabled:text-gray-600', className, iconKey ? 'pe-10' : '')
      }, props)), trailingSlot || iconKey ? /*#__PURE__*/_jsxs("div", {
        className: "pointer-events-none absolute inset-y-0 end-0 flex items-center gap-2 pe-3 text-gray-600",
        children: [trailingSlot, iconKey ? /*#__PURE__*/_jsx(Icon, {
          iconKey: iconKey,
          size: "24px"
        }) : null]
      }) : null]
    })]
  });
});
export default BaseInput;